import React, { memo, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { CompanyActions } from '../../../store/actions/companies';
import { PlanActions } from '../../../store/actions/plans';

import ModalCustomPlanos from './Modal/ModalCustomPlanos';

import webchat from '../../../assets/images/webchat_icon.svg';
import messenger from '../../../assets/images/messenger_icon.svg';
import whatsapp from '../../../assets/images/whatsapp_icon.svg';
import instagram from '../../../assets/images/instagram_icon.svg';

import './Plan.css';

function TypePlan(props) {
  const { plan, company, user } = props;
  const { changePlan } = props;
  const { name, value, amountAgent, franchise } = plan;

  const channelsIcon = (channel) => {
    const channels = {
      webchat,
      messenger,
      whatsapp,
      instagram,
    };
    return channels[channel];
  };

  const cardsPlans = (plan) => {
    const plans = {
      false: 'container-type-plan marginRight',
      true: 'container-type-plan',
    };
    return plans[plan];
  };

  const handleSelectPlan = () => {
    const payload = {
      responsible: user._id,
      planId: plan._id,
      companyId: company._id,
    };
    changePlan(payload);
  };

  const handleAgenteText = () => {
    switch (amountAgent) {
      case 0:
        return `n agentes`;
      case 1:
        return `${amountAgent} agente`;
      default:
        return `${amountAgent} agentes`;
    }
  };

  const handleValueText = () => {
    switch (value) {
      case 0:
        if (name === 'Enterprise') return `0`;
        return value;
      default:
        return value;
    }
  };

  const isCSorRoot = useMemo(() => {
    return (
      user?.selectedCompany?.claim?.name === 'CS' ||
      user?.selectedCompany?.claim?.name === 'Root'
    );
  }, [user]);

  const isCustom = useMemo(() => {
    return name === 'Enterprise';
  }, [name]);

  const handleTextChannel = (channel) => {
    let text = '';

    if (plan.name.toLowerCase() === 'starter') {
      if (channel === 'whatsapp') {
        text = plan?.amountWhatsappConversation;
      } else if (channel === 'messenger') {
        text = 'Ilimitado';
      } else {
        text = 'Ilimitado';
      }

      return text;
    }
    if (plan.name.toLowerCase() === 'freemium') {
      text = '1000';
      return text;
    }

    return channel === 'whatsapp'
      ? plan?.amountWhatsappConversation
      : 'Ilimitado';
  };

  return (
    <>
      <div className={cardsPlans(isCustom)}>
        <div
          className={
            isCustom
              ? 'container-type-plan-top-custom'
              : 'container-type-plan-top'
          }
        >
          <div>{isCustom ? 'ENTERPRISE' : name.toUpperCase()}</div>
          {!isCustom && (
            <div>
              R$<span>{handleValueText()}</span>,00
            </div>
          )}
        </div>
        {!isCustom && (
          <>
            <div className="container-type-plan-mid">
              <div>{handleAgenteText()}</div>
              <div>Atendimento Humano</div>
            </div>
            <div className="type-plan-line" />
            <div className="container-type-channels">
              <>
                <div className="container-item-type-channels">
                  <div>
                    <span>Conversas</span>
                  </div>
                  <div className="plans-img">
                    {plan.name !== 'Enterprise'
                      ? plan?.availableChannels?.map((channel) => (
                          <div key={channel}>
                            <img src={channelsIcon(channel)} alt="" />
                            {handleTextChannel(channel)}
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </>
            </div>

            <div className="container-type-plan-bottom">
              {!isCustom &&
                (isCSorRoot ? (
                  <div onClick={() => handleSelectPlan()}>selecionar</div>
                ) : (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://api.whatsapp.com/send?phone=5511993144263&text=Oi%20gostaria%20de%20saber%20mais%20sobre%20os%20planos%20da%20code7%20boteria"
                  >
                    contactar
                  </a>
                ))}
            </div>
          </>
        )}
        {isCustom && (
          <>
            <div className="text-enterprise-plan">
              Um pacote sob demanda só para sua empresa
            </div>

            <div className="container-type-plan-bottom">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://api.whatsapp.com/send?phone=5511993144263&text=Oi%20gostaria%20de%20saber%20mais%20sobre%20os%20planos%20da%20code7%20boteria"
              >
                contactar
              </a>
            </div>
          </>
        )}

        {/* isCustom && (
          <div className="container-type-plan-bottom">
            {isCSorRoot ? (
              <div data-toggle="modal" data-target="#enterprisePersonalization">
                personalizar
              </div>
            ) : (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://api.whatsapp.com/send?phone=5511993144263&text=Oi%20gostaria%20de%20saber%20mais%20sobre%20os%20planos%20da%20code7%20boteria"
              >
                contactar
              </a>
            )}
          </div>
            ) */}
      </div>

      <div
        className="modal fade"
        id="enterprisePersonalization"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="enterprisePersonalization"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <ModalCustomPlanos />
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  company: state.companies.company,
  companyMessagesPerBot: state.reports.companyMessagesPerBot,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...CompanyActions,
      ...PlanActions,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(memo(TypePlan))
);
